import React, { InputHTMLAttributes } from 'react'
import { Field } from "formik"
import './TextInput.scss'

interface ITextInput extends InputHTMLAttributes<HTMLInputElement> {
}

const TextInput: React.FC<ITextInput> = (props) => {
    const { onClick, disabled } = props
    console.log('disabled', disabled)

    return (
        <label htmlFor="" className={"text-input"}>
            <Field
                disabled={disabled}
                name={"message"}
                placeholder={"Напишите сообщение..."}
                id={"chat-input"}
            />
            <div
                className={"text-input__icon"}
                onClick={onClick}
            >
                <img src="/misc/input-icon.svg" alt=""/>
            </div>
        </label>
    )
}

export default TextInput